import React, { useMemo } from 'react';
import InfluencerTable from '@op/pages/Influencer/BrandCreatorList/widgets/InfluencerTable';
import '@op/assets/scss/pages/community/influencer.scss';
import './index.scss';
import { JumpType } from '@home/utils/utils';

const OpinionsVideoInFluencers = (props: any) => {
  const { gameInfo, wholeGameInfo, filter, extraParams, mediaType = 'video', defaultPageSize = 5, tableDefaultSortKey = "views" } = props || {};
  const params = useMemo(() => {
    if (!filter?.date_type) return {};
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    return { ...(restFilter || {}), ...extraParams };
  }, [extraParams, filter]);

  return (
    <div className='dbh-opinions-video-influencers'>
      <InfluencerTable
        mediaType={mediaType}
        params={params}
        wholeGameInfo={wholeGameInfo}
        gameInfo={gameInfo}
        hasKolTagsFilter={false}
        hasIndex={false}
        defaultPageSize={defaultPageSize}
        tableDefaultSortKey={tableDefaultSortKey}
        filterOptionsKey={["posts", "views", "engagements", "view_per_posts", "keywords"]}
        jumpType={JumpType.Window}
      >
        {() => <></>}
      </InfluencerTable>
    </div>
  );
};

export default OpinionsVideoInFluencers;
